export const GLOBAL_HANDLER = 'GLOBAL_HANDLER'
export const GET_MESSAGE_LIMIT = 30
export const INIT_SENDBIRD = 'INIT_SENDBIRD'
export const MAX_COUNT = '+9'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const ADD_ATTACHMENT_MESSAGE = 'ADD_ATTACHMENT_MESSAGE'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const SET_TYPING = 'SET_TYPING'
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES'
export const RESET_CHAT_MESSAGES = 'RESET_CHAT_MESSAGES'
export const SET_MESSAGECOUNTS = 'SET_MESSAGECOUNTS'
export const RESET_CHANNELS = 'RESET_CHANNELS'
export const SET_CHANNELS = 'SET_CHANNELS'



// WEBPACK FOOTER //
// ./src/store/modules/chat/types.js